import { render, staticRenderFns } from "./DocumentsSection.vue?vue&type=template&id=34c3a6e6&"
import script from "./DocumentsSection.js?vue&type=script&lang=js&"
export * from "./DocumentsSection.js?vue&type=script&lang=js&"
import style0 from "./DocumentsSection.vue?vue&type=style&index=0&id=34c3a6e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports